import ImageTile from "./ImageTile";

export interface IImageTile {
    ID: number;
    ImageURL: string;
    Title?: string;
    ParentId: string;
    Selected?: boolean;
}

export interface IImageTileProps {
    ID: number;
    Title?: string;
    ImageURL: string;
    OnClick: (id: number) => void;
    Selected?: boolean;
}

export type ImageState = "ShowImage" | "ShowAlternative";

export { ImageTile };
